import { render, staticRenderFns } from "./uppy_cars.vue?vue&type=template&id=16861a59&scoped=true"
import script from "./uppy_cars.vue?vue&type=script&lang=js"
export * from "./uppy_cars.vue?vue&type=script&lang=js"
import style0 from "./uppy_cars.vue?vue&type=style&index=0&id=16861a59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16861a59",
  null
  
)

export default component.exports